import { render, staticRenderFns } from "./data_screen.vue?vue&type=template&id=679737aa&scoped=true&"
import script from "./data_screen.vue?vue&type=script&lang=js&"
export * from "./data_screen.vue?vue&type=script&lang=js&"
import style0 from "./data_screen.vue?vue&type=style&index=0&id=679737aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679737aa",
  null
  
)

export default component.exports